module.exports = __webpack_public_path__ + "media/images/img_entry-3dab082eed927aba3322d84b18702a09.svg";